/*
  KASA Punktekonto — Partnerprogramm.
  Zwei Custom Elements:
    <punkte-konto>      Seite „Meine Punkte"  (GET /apps/bonus/konto, Rückfall auf Customer-Metafelder)
    <punkte-warenkorb>  Einlöseblock im Warenkorb (POST /apps/bonus/warenkorb, POST /apps/bonus/einloesen)

  Grundsatz: Das Theme rechnet keine Punkte. Alle Zahlen kommen aus dem App-Proxy (Wahrheit)
  oder – nur wenn der Proxy nicht antwortet – aus den Metafeldern (Spiegel, mit „Stand vom …").
  Eingelöst wird ausschließlich über den Rabattcode aus dem Endpunkt: /discount/<code>?redirect=/cart.
  Kein localStorage/sessionStorage für Punktestände.
*/
(function () {
  'use strict';
  if (window.KasaPunkte) return;

  /* ---------- Hilfen ---------- */
  var HEUTE_MS = 86400000;

  function ganz(n) {
    var x = Number(n);
    return isFinite(x) ? Math.round(x) : 0;
  }
  /* Deutsches Zahlenformat mit Punkt als Tausendertrenner (1075 -> 1.075), unabhängig von der Browser-Locale. */
  function fmtZahl(n) {
    var v = ganz(n), neg = v < 0;
    var s = String(Math.abs(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (neg ? '−' : '') + s;
  }
  function fmtPunkte(n) { return fmtZahl(n); }
  function fmtEuro(n) { return fmtZahl(n) + ' €'; }
  function fmtDatum(iso) {
    if (!iso) return '';
    var m = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? m[3] + '.' + m[2] + '.' + m[1] : String(iso);
  }
  function tageBis(iso, heuteIso) {
    var a = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    var b = String(heuteIso || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!a) return null;
    var ziel = Date.UTC(+a[1], +a[2] - 1, +a[3]);
    var heute = b ? Date.UTC(+b[1], +b[2] - 1, +b[3]) : (function () { var d = new Date(); return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()); })();
    return Math.round((ziel - heute) / HEUTE_MS);
  }
  /* Periode aus dem Journal (2026Q3) lesbar machen: Q3/2026 */
  function fmtPeriode(p) {
    var m = String(p || '').match(/^(\d{4})Q([1-4])$/);
    return m ? 'Q' + m[2] + '/' + m[1] : String(p || '');
  }
  function fmtSatz(satz) {
    var z = parseFloat(satz);
    return isFinite(z) && z > 0 ? String(satz).replace('.', ',') + ' %' : '';
  }
  function heuteIso() {
    var d = new Date(), p = function (x) { return (x < 10 ? '0' : '') + x; };
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function arr(x) { return Array.isArray(x) ? x : []; }
  function parseJsonEl(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }
  var idZaehler = 0;
  function uid(prefix) { idZaehler += 1; return prefix + '-' + idZaehler; }

  function api(url, options) {
    var opts = options || {};
    var init = {
      method: opts.method || 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    };
    if (opts.body !== undefined) {
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(opts.body);
    }
    return fetch(url, init).then(function (res) {
      return res.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
        return { status: res.status, data: data };
      });
    });
  }

  /* Beispieldaten NUR für die Entwicklung. Werden ausschließlich benutzt, wenn die Section-Einstellung
     „Testdaten" eingeschaltet ist (Auslieferungszustand: aus). Zahlen = Beispiel aus dem Endpunkt-Vertrag. */
  var DEMO_KONTO = {
    ok: true, teilnehmer: true, name: 'Salon Beispiel', punkte: 1075, gebunden: 0, einloesbar: 1075,
    anwartschaft: 287, stufe: 'Gold', satz: 6, stichtag: '2026-09-23', gestoppt: null,
    posten: [
      { punkte: 564, ab: '2026-04-01', bis: '2026-09-30', periode: '2026Q1' },
      { punkte: 511, ab: '2026-07-01', bis: '2026-12-31', periode: '2026Q2' }
    ],
    posten_kuenftig: [{ punkte: 287, ab: '2026-10-01', bis: '2027-03-31', periode: '2026Q3' }],
    buchungen: [
      { ts: '2026-09-15T05:20:00+02:00', art: 'migration', punkte: 1075, periode: '2026Q2', grund: 'Übernahme aus der bisherigen Excel-Mappe' },
      { ts: '2026-09-17T10:12:00+02:00', art: 'korrektur', punkte: -120, grund: 'Retoure zu Bestellung #30412' },
      { ts: '2026-09-23T05:40:00+02:00', art: 'stufe', punkte: 0, stufe: 'Gold', satz: 6, richtung: 'auf', gilt_bis: '2027-03-31' },
      { ts: '2026-10-01T05:20:00+02:00', art: 'verfall', punkte: -564, periode: '2026Q1' },
      { ts: '2026-10-01T05:40:00+02:00', art: 'gutschrift', punkte: 287, periode: '2026Q3', einloesbar_ab: '2026-10-01', gueltig_bis: '2027-03-31' },
      { ts: '2026-10-02T09:00:00+02:00', art: 'unbekannt', punkte: 5, quelle: 'test', kunde: 1, name: 'x', bezug: 'y' }
    ]
  };

  /* ---------- Seite „Meine Punkte" ---------- */
  var TXT = {
    laden: 'Punktestand wird geladen …',
    login: 'Bitte melde dich an, um dein Punktekonto zu sehen.',
    loginBtn: 'Anmelden',
    keinTeilnehmer: 'Du nimmst am Partnerprogramm derzeit nicht teil. Dein Außendienstmitarbeiter sagt dir gerne, wie das geht.',
    nichtAbrufbar: 'Dein Punktestand ist gerade nicht abrufbar. Bitte versuch es später noch einmal.',
    gestoppt: 'Die Einlösung ist gerade vorübergehend nicht möglich. Der Innendienst ist informiert.',
    regel: '1 Punkt = 1 € Rabatt auf den Nettobetrag.',
    standVom: 'Stand vom ',
    standHinweis: 'Der Live-Stand ist gerade nicht erreichbar, gezeigt wird der letzte gespeicherte Stand.',
    einloesbar: 'Einlösbar',
    punkte: 'Punkte',
    reserviert: ' Punkte sind gerade für eine laufende Einlösung reserviert.',
    aufbau: 'Im Aufbau',
    aufbauOhneDatum: 'werden nach Quartalsende gutgeschrieben.',
    tranchen: 'Deine Tranchen',
    keineTranchen: 'Derzeit keine offenen Tranchen.',
    stufe: 'Stufe und Satz',
    satzText: ' auf den Nettoumsatz',
    buchungen: 'Letzte Buchungen',
    keineBuchungen: 'Noch keine Buchungen.',
    keineBuchungenUebernahme: 'Noch keine Buchungen. Dein übernommener Punktestand ist oben in den Tranchen enthalten.',
    wofuer: 'Wofür einlösbar',
    zurKollektion: 'Zu den Prämien',
    zumWarenkorb: 'Zum Warenkorb',
    gutschrift: 'Gutschrift',
    einloesung: 'Einlösung',
    quartal: 'Quartal ',
    beleg: 'Beleg ',
    umsatz: 'Umsatz '
  };

  /* Buchungsarten nach Endpunkt-Vertrag 4.2 (23.09.2026). Unbekannte Arten werden neutral gezeigt. */
  var ART_LABEL = {
    migration: 'Übernahme aus dem bisherigen Programm',
    korrektur: 'Korrektur',
    stufe: 'Stufe',
    gutschrift: 'Gutschrift',
    verfall: 'Verfallen',
    einloesung: 'Eingelöst',
    storno: 'Storniert',
    freigabe: 'Freigabe',
    reservierung: 'Reservierung'
  };

  function metafeldZuKonto(f) {
    if (!f) return null;
    var hatIrgendwas = f.stand || f.punkte != null || f.anwartschaft != null || arr(f.posten).length;
    if (!hatIrgendwas) return null;
    return {
      ok: true,
      teilnehmer: true,
      rueckfall: true,
      stand: f.stand || '',
      punkte: f.punkte,
      einloesbar: f.punkte,
      anwartschaft: f.anwartschaft,
      verfaellt_am: f.verfaellt_am || '',
      stufe: f.stufe || '',
      satz: f.satz,
      posten: arr(f.posten),
      posten_kuenftig: [],
      buchungen: arr(f.buchungen),
      gestoppt: null
    };
  }

  class PunkteKonto extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.url = this.dataset.url || '/apps/bonus/konto';
      this.praemienUrl = this.dataset.praemienUrl || '';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.loginUrl = this.dataset.loginUrl || '/account/login';
      this.wofuerText = this.dataset.wofuerText || '';
      /* Stichtag für den Verlauf (JJJJ-MM-TT, Section-Einstellung). Ungültig oder leer = kein Stichtag. */
      var ab = String(this.dataset.buchungenAb || '').trim();
      this.buchungenAb = /^\d{4}-\d{2}-\d{2}$/.test(ab) ? ab : '';
      this.out = this.querySelector('[data-kp-out]') || this;
      this.fallback = parseJsonEl(this.querySelector('[data-kp-fallback]'));
      this.demo = this.hasAttribute('data-demo');
      this.laden();
    }

    laden() {
      var self = this;
      if (this.demo) { this.render(DEMO_KONTO, { demo: true }); return; }
      api(this.url).then(function (r) {
        if (r.status === 401) { self.renderLogin(); return; }
        if (r.status === 403) { console.warn('[punkte] App-Proxy antwortet 403 (Signatur/Konfiguration), Rückfall auf Metafelder.', r.data); self.renderRueckfall(); return; }
        if (r.status >= 200 && r.status < 300 && r.data && r.data.ok === true) { self.render(r.data, {}); return; }
        self.renderRueckfall();
      }).catch(function () { self.renderRueckfall(); });
    }

    zeigen(html) {
      var loading = this.querySelector('[data-kp-loading]');
      if (loading) loading.hidden = true;
      this.out.innerHTML = html;
      this.out.hidden = false;
    }

    renderLogin() {
      this.zeigen(
        '<div class="kp__card"><p>' + esc(TXT.login) + '</p>' +
        '<div class="kp__actions"><a class="button" href="' + esc(this.loginUrl) + '">' + esc(TXT.loginBtn) + '</a></div></div>'
      );
    }

    renderRueckfall() {
      var k = metafeldZuKonto(this.fallback);
      if (!k) { this.zeigen('<div class="kp__card"><p class="kp__notice">' + esc(TXT.nichtAbrufbar) + '</p></div>'); return; }
      this.render(k, { rueckfall: true });
    }

    render(k, meta) {
      var html = '';
      if (meta && meta.rueckfall) {
        html += '<p class="kp__stand" role="status">' + esc(TXT.standVom + (fmtDatum(k.stand) || '–')) + ' · ' + esc(TXT.standHinweis) + '</p>';
      }
      if (meta && meta.demo) html += '<span class="kp__demo">TESTDATEN – nicht dein Stand</span>';

      if (k.teilnehmer === false) {
        html += '<div class="kp__card"><p class="kp__notice">' + esc(TXT.keinTeilnehmer) + '</p></div>';
        this.zeigen(html);
        return;
      }

      var heute = k.stichtag || heuteIso();
      var einloesbar = k.einloesbar != null ? k.einloesbar : k.punkte;
      var posten = arr(k.posten);
      var kuenftig = arr(k.posten_kuenftig);

      /* 1. Einlösbar */
      html += '<div class="kp__card">';
      html += '<p class="kp__kicker">' + esc(TXT.einloesbar) + '</p>';
      html += '<p class="kp__big"><span class="kp__big-num">' + esc(fmtPunkte(einloesbar)) + '</span><span class="kp__big-unit">' + esc(TXT.punkte) + '</span></p>';
      html += '<p class="kp__sub">' + esc(TXT.regel) + '</p>';
      if (ganz(k.gebunden) > 0) html += '<p class="kp__sub">' + esc(fmtPunkte(k.gebunden) + TXT.reserviert) + '</p>';

      /* 2. Warnzeile: Tranche verfällt innerhalb von 60 Tagen */
      var bald = posten.filter(function (p) { var t = tageBis(p.bis, heute); return t !== null && t >= 0 && t <= 60; });
      if (bald.length) {
        html += '<div class="kp__warn" role="status">';
        bald.forEach(function (p) {
          html += '<p>davon ' + esc(fmtPunkte(p.punkte)) + ' nur noch bis ' + esc(fmtDatum(p.bis)) + '</p>';
        });
        html += '</div>';
      } else if (!posten.length && k.verfaellt_am) {
        var t = tageBis(k.verfaellt_am, heute);
        if (t !== null && t >= 0 && t <= 60) {
          html += '<div class="kp__warn" role="status"><p>Die älteste Tranche verfällt am ' + esc(fmtDatum(k.verfaellt_am)) + '</p></div>';
        }
      }
      if (k.gestoppt) html += '<p class="kp__notice" style="margin-top:1.2rem">' + esc(TXT.gestoppt) + '</p>';
      html += '</div>';

      /* 3. Im Aufbau */
      if (ganz(k.anwartschaft) > 0 || kuenftig.length) {
        html += '<div class="kp__card">';
        html += '<p class="kp__kicker">' + esc(TXT.aufbau) + '</p>';
        if (k.anwartschaft != null) {
          html += '<p class="kp__big"><span class="kp__big-num" style="font-size:3rem">' + esc(fmtPunkte(k.anwartschaft)) + '</span><span class="kp__big-unit">' + esc(TXT.punkte) + '</span></p>';
        }
        if (kuenftig.length) {
          kuenftig.forEach(function (p) {
            html += '<p class="kp__sub">' + esc(fmtPunkte(p.punkte)) + ' Punkte – ab ' + esc(fmtDatum(p.ab)) + ' einlösbar, gültig bis ' + esc(fmtDatum(p.bis)) + '</p>';
          });
        } else {
          html += '<p class="kp__sub">' + esc(TXT.aufbauOhneDatum) + '</p>';
        }
        html += '</div>';
      }

      html += '<div class="kp__grid">';
      /* 4. Tranchentabelle */
      html += '<div class="kp__card"><p class="kp__kicker">' + esc(TXT.tranchen) + '</p>';
      if (posten.length) {
        html += '<table class="kp__table"><thead><tr><th scope="col">Punkte</th><th scope="col">Einlösbar ab</th><th scope="col">Gültig bis</th></tr></thead><tbody>';
        posten.forEach(function (p) {
          var t = tageBis(p.bis, heute);
          var soon = t !== null && t >= 0 && t <= 60;
          html += '<tr' + (soon ? ' class="kp__table--soon"' : '') + '>';
          html += '<td class="kp__num">' + esc(fmtPunkte(p.punkte)) + (p.periode ? '<span class="kp__periode">' + esc(p.periode) + '</span>' : '') + '</td>';
          html += '<td>' + esc(fmtDatum(p.ab)) + '</td><td>' + esc(fmtDatum(p.bis)) + '</td></tr>';
        });
        html += '</tbody></table>';
      } else {
        html += '<p class="kp__sub">' + esc(TXT.keineTranchen) + '</p>';
      }
      html += '</div>';

      /* 5. Stufe und Satz – nur wenn eine Stufe gesetzt ist. Ohne Stufe liefert der
         Endpunkt satz = 0 (nicht null); dann entfällt die Karte ganz (Auftrag 23.09., 7.5). */
      var stufe = k.stufe ? String(k.stufe) : '';
      var satz = fmtSatz(k.satz);
      if (stufe) {
        html += '<div class="kp__card"><p class="kp__kicker">' + esc(TXT.stufe) + '</p>';
        html += '<p class="kp__big" style="font-size:2rem;font-weight:600">' + esc(stufe) + (satz ? ' · ' + esc(satz + TXT.satzText) : '') + '</p>';
        html += '</div>';
      }
      html += '</div>';

      /* 6. Letzte Buchungen (zwölf, neueste zuerst).
         Partner sehen keine Aufbau- oder Testbuchungen (Entscheid Fabsl 24.09.2026):
         - migration (Übernahme aus der Mappe) erscheint nie,
         - einloesung, storno, gutschrift, verfall sind echte Ereignisse und erscheinen immer,
         - alles andere (korrektur, stufe, unbekannt) erst ab dem Stichtag buchungenAb.
         Der Stand selbst bleibt vollständig: Punkte und Tranchen kommen unverändert vom Server.
         Seit 02.10.2026 filtert der Server /konto nach denselben Regeln (Runbook 78, sichtbar:false);
         dieser Filter bleibt als zweite Sicherung, vor allem für den Rückfall auf den Spiegel. */
      var abTag = this.buchungenAb;
      var IMMER = { einloesung: 1, storno: 1, gutschrift: 1, verfall: 1 };
      var alleBuchungen = arr(k.buchungen);
      var sichtbar = alleBuchungen.filter(function (b) {
        if (!b) return false;
        var a = String(b.art || '').toLowerCase();
        if (a === 'migration') return false;
        if (IMMER[a]) return true;
        if (!abTag) return true;
        return String(b.ts || '').slice(0, 10) >= abTag;
      });
      var buch = sichtbar.slice().sort(function (a, b) { return String(b.ts || '').localeCompare(String(a.ts || '')); }).slice(0, 12);
      html += '<div class="kp__card"><p class="kp__kicker">' + esc(TXT.buchungen) + '</p>';
      if (buch.length) {
        html += '<ul class="kp__journal">';
        buch.forEach(function (b) {
          var art = String(b.art || '').toLowerCase();
          var label = ART_LABEL[art] || (b.art ? String(b.art) : 'Buchung');
          var teile = [];
          var p = ganz(b.punkte);
          var betragZeigen = true;
          if (art === 'gutschrift') {
            if (b.periode) label += ' ' + fmtPeriode(b.periode);
            if (b.einloesbar_ab) teile.push('einlösbar ab ' + fmtDatum(b.einloesbar_ab));
            if (b.gueltig_bis) teile.push('gültig bis ' + fmtDatum(b.gueltig_bis));
          } else if (art === 'stufe') {
            /* K3 (Wortlaut bei Stufenverlust), gesetzt 02.10.2026 im Auftrag von Fabsl:
               „Neue Einstufung: Gold · 6 %" bzw. „Neue Einstufung: derzeit ohne Stufe" mit dem Zusatz,
               dass die gesammelten Punkte einlösbar bleiben. */
            var st = b.stufe ? String(b.stufe) : '';
            var sz = fmtSatz(b.satz);
            label = st ? 'Neue Einstufung: ' + st + (sz ? ' · ' + sz : '') : 'Neue Einstufung: derzeit ohne Stufe';
            if (!st) teile.push('Deine gesammelten Punkte bleiben einlösbar');
            if (b.gilt_bis) teile.push('gilt bis ' + fmtDatum(b.gilt_bis));
            if (p === 0) betragZeigen = false;
          } else if (art === 'korrektur' || art === 'einloesung' || art === 'storno') {
            /* nur Punkte und ggf. Grund */
          } else {
            if (b.periode) teile.push(fmtPeriode(b.periode));
          }
          /* grund ist für den Partner sichtbar (Entscheid Fabsl 17.09.2026) – immer als Text.
             quelle, kunde, name, bezug sind intern und werden nie ausgegeben. */
          if (b.grund) teile.push(String(b.grund));
          var detail = teile.join(' · ');
          var betrag = betragZeigen ? (p > 0 ? '+' : (p < 0 ? '−' : '')) + fmtPunkte(Math.abs(p)) : '';
          html += '<li><span class="kp__journal-date">' + esc(fmtDatum(b.ts)) + '</span>';
          html += '<span class="kp__journal-text">' + esc(label) + (detail ? '<small>' + esc(detail) + '</small>' : '') + '</span>';
          html += '<span class="kp__journal-amt' + (p < 0 ? ' kp__journal-amt--minus' : '') + '">' + esc(betrag) + '</span></li>';
        });
        html += '</ul>';
      } else {
        /* buchungen_gesamt (Server, seit 02.10.2026) zählt auch die ausgeblendeten Buchungen. */
        var gibtVerdeckte = alleBuchungen.length > 0 || ganz(k.buchungen_gesamt) > 0;
        html += '<p class="kp__sub">' + esc(gibtVerdeckte ? TXT.keineBuchungenUebernahme : TXT.keineBuchungen) + '</p>';
      }
      html += '</div>';

      /* 7. Wofür einlösbar */
      html += '<div class="kp__card"><p class="kp__kicker">' + esc(TXT.wofuer) + '</p>';
      if (this.wofuerText) html += '<p>' + esc(this.wofuerText) + '</p>';
      html += '<div class="kp__actions">';
      /* Der Link auf die Praemien-Kollektion bleibt leer, solange sie in keinem
         Verkaufskanal veroeffentlicht ist (Entscheid Fabsl 16.09.2026: Link
         weglassen). Adresse im Section-Schema setzen, dann erscheint er wieder. */
      if (this.praemienUrl) {
        html += '<a class="button" href="' + esc(this.praemienUrl) + '">' + esc(TXT.zurKollektion) + '</a>';
      }
      if (!k.gestoppt && !(meta && meta.rueckfall) && ganz(einloesbar) > 0) {
        html += '<a class="button button--secondary" href="' + esc(this.cartUrl) + '">' + esc(TXT.zumWarenkorb) + '</a>';
      }
      html += '</div></div>';

      this.zeigen(html);
    }
  }
  if (!customElements.get('punkte-konto')) customElements.define('punkte-konto', PunkteKonto);

  /* ---------- Warenkorb-Block ---------- */
  /* Seit 24.09.2026 ist der BONUS-Code ein Produktrabatt auf die Kollektion „Bonuspunkte-Prämien"
     (fester Eurobetrag, einmal je Bestellung). Shopify begrenzt ihn damit selbst auf Prämienartikel.
     Trägt eine Prämienzeile schon einen Regios-Rabatt, gilt je Zeile nur der bessere – angerechnet
     wird dann weniger als der Code, im Extremfall nichts. Deshalb zeigt der Block nach dem Einlösen
     immer den tatsächlich angerechneten Betrag (total_allocated_amount), nie den Codebetrag. */
  var CTXT = {
    kicker: 'Punkte einlösen',
    nichtsFaehig: function (p) { return 'Du hast ' + fmtPunkte(p) + ' Punkte. In diesem Warenkorb ist nichts Prämienfähiges.'; },
    faehigVon: function (a, b) { return a + ' von ' + b + ' Positionen ' + (a === 1 ? 'ist' : 'sind') + ' prämienfähig'; },
    verfuegbar: function (p) { return 'Verfügbar: ' + fmtPunkte(p) + ' Punkte'; },
    teaser: function (v) { return 'Diese Bestellung kann bis zu ' + fmtPunkte(v) + ' Punkte kosten.'; },
    regel: '1 Punkt = 1 € Rabatt auf die prämienfähigen Artikel',
    label: 'Wie viele Punkte möchtest du einlösen?',
    effekt: function (v) { return fmtPunkte(v) + ' Punkte = bis zu ' + fmtEuro(v) + ' Rabatt'; },
    hinweis: '„Bis zu", weil bei einem Prämienartikel mit anderem Rabatt nur der bessere gilt. Abgebucht wird nur, was tatsächlich angerechnet wird – der Rest bleibt auf deinem Konto.',
    knopf: 'Punkte einlösen',
    knopfLaeuft: 'Wird eingelöst …',
    gestoppt: 'Die Einlösung ist gerade vorübergehend nicht möglich. Der Innendienst ist informiert.',
    fehler: 'Die Einlösung hat nicht geklappt. Bitte versuch es noch einmal.',
    angewendet: 'Punkte eingelöst:',
    angerechnet: function (b) { return 'angerechnet −' + b; },
    angewendetHinweis: 'Der Rabatt steht bei den prämienfähigen Artikeln. Abgebucht wird nur der angerechnete Betrag.',
    nichtAngerechnet: function (c) { return 'Dein Punkte-Code ' + c + ' wird in diesem Warenkorb gerade nicht angerechnet – zum Beispiel, weil für die Prämienartikel schon ein höherer Rabatt gilt oder keine Prämienartikel mehr im Warenkorb sind. Dafür werden keine Punkte abgebucht.'; },
    codeEntfernen: 'Code entfernen',
    wirdEntfernt: 'Code wird entfernt …',
    entfernenFehler: 'Der Code konnte nicht entfernt werden. Bitte lade die Seite neu.',
    mehr: 'Mein Punktekonto',
    probe: 'Probebetrieb: Es wird kein echter Rabattcode ausgestellt.',
    nichtGedeckt: 'Der Betrag ist nicht mehr gedeckt. Bitte prüfe den Warenkorb und versuch es noch einmal.',
    spaeter: 'Die Einlösung ist gerade nicht möglich. Bitte versuch es später noch einmal.',
    nochmalAnmelden: 'Bitte melde dich erneut an.'
  };

  class PunkteWarenkorb extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.urlWarenkorb = this.dataset.urlWarenkorb || '/apps/bonus/warenkorb';
      this.urlEinloesen = this.dataset.urlEinloesen || '/apps/bonus/einloesen';
      this.punkteUrl = this.dataset.punkteUrl || '/pages/punkte';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.cartUpdateUrl = this.dataset.cartUpdateUrl || '/cart/update';
      this.body = this.querySelector('[data-kp-body]') || this;
      this.probe = this.hasAttribute('data-probe');
      this.busy = false;
      try { this.positionen = JSON.parse(this.dataset.positionen || '[]'); } catch (e) { this.positionen = []; }
      if (!Array.isArray(this.positionen)) this.positionen = [];

      /* Im Drawer erst abrufen, wenn er tatsächlich geöffnet wird. */
      var drawer = this.closest('cart-drawer');
      if (drawer && !drawer.classList.contains('active')) {
        var self = this;
        this._mo = new MutationObserver(function () {
          if (drawer.classList.contains('active')) { self._mo.disconnect(); self._mo = null; self.laden(); }
        });
        this._mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        return;
      }
      this.laden();
    }

    disconnectedCallback() {
      if (this._mo) { this._mo.disconnect(); this._mo = null; }
    }

    zeigen(html) { this.body.innerHTML = html; this.hidden = false; }
    verstecken() { this.hidden = true; this.body.innerHTML = ''; }
    kopf() { return '<div class="kp-cart__box"><p class="kp-cart__kicker">' + esc(CTXT.kicker) + '</p>'; }
    fuss() { return '<p class="kp-cart__meta"><a href="' + esc(this.punkteUrl) + '">' + esc(CTXT.mehr) + '</a></p></div>'; }

    laden() {
      var self = this;
      /* Angewandter BONUS-Code: Liquid liefert Code und angerechneten Betrag, kein Abruf nötig. */
      if (this.dataset.code) {
        if (ganz(this.dataset.codeCent) > 0) this.renderAngewendet();
        else this.renderNichtAngerechnet(this.dataset.code);
        return;
      }
      if (!this.positionen.length) { this.verstecken(); return; }
      /* Parallel: Höchstbetrag vom Proxy und die Codeliste von Shopify (/cart.js, kein Proxy).
         Die Codeliste zeigt einen BONUS-Code, den Shopify nicht anrechnet (applicable:false) –
         den sieht Liquid nicht, weil er in keiner discount_application auftaucht. */
      var warenkorb = api(this.urlWarenkorb, { method: 'POST', body: { positionen: this.positionen } });
      var codes = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .catch(function () { return null; });
      Promise.all([warenkorb, codes]).then(function (erg) {
        if (!self.isConnected) return;
        var r = erg[0], c = erg[1];
        var offen = arr(c && c.discount_codes).filter(function (x) {
          return x && x.code && String(x.code).toUpperCase().indexOf('BONUS') === 0 && x.applicable === false;
        })[0];
        if (offen) { self.renderNichtAngerechnet(String(offen.code)); return; }
        var d = r.data;
        if (r.status === 403) console.warn('[punkte] App-Proxy antwortet 403 (Signatur/Konfiguration).', d);
        if (r.status !== 200 || !d || d.ok !== true || d.teilnehmer === false) { self.verstecken(); return; }
        self.renderStand(d);
      }).catch(function () { if (self.isConnected) self.verstecken(); });
    }

    renderAngewendet() {
      var code = this.dataset.code, betrag = this.dataset.codeBetrag || '';
      this.zeigen(
        this.kopf() +
        '<p class="kp-cart__applied"><span>' + esc(CTXT.angewendet) + '</span><code>' + esc(code) + '</code>' + (betrag ? '<span>' + esc(CTXT.angerechnet(betrag)) + '</span>' : '') + '</p>' +
        '<p class="kp-cart__meta">' + esc(CTXT.angewendetHinweis) + '</p>' +
        this.fuss()
      );
    }

    renderNichtAngerechnet(code) {
      var self = this;
      this.zeigen(
        this.kopf() +
        '<p class="kp-cart__notice" role="status">' + esc(CTXT.nichtAngerechnet(code)) + '</p>' +
        '<button type="button" class="button button--secondary kp-cart__entfernen">' + esc(CTXT.codeEntfernen) + '</button>' +
        '<p class="kp-cart__error" role="alert" hidden></p>' +
        this.fuss()
      );
      var btn = this.body.querySelector('.kp-cart__entfernen');
      var err = this.body.querySelector('.kp-cart__error');
      btn.addEventListener('click', function () { self.codeEntfernen(code, btn, err); });
    }

    /* Entfernt nur den genannten Code aus dem Warenkorb, andere Codes bleiben (Cart AJAX API, discount-Parameter). */
    codeEntfernen(code, btn, err) {
      var self = this;
      var ziel = String(code || '').toUpperCase();
      btn.disabled = true;
      btn.textContent = CTXT.wirdEntfernt;
      err.hidden = true;
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (c) {
          var rest = arr(c && c.discount_codes)
            .map(function (x) { return x && x.code ? String(x.code) : ''; })
            .filter(function (x) { return x && x.toUpperCase() !== ziel; });
          return fetch(self.cartUpdateUrl + '.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: rest.join(',') })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('cart/update ' + res.status);
          window.location.replace(self.cartUrl);
        })
        .catch(function (e) {
          console.warn('[punkte] BONUS-Code konnte nicht entfernt werden.', e);
          btn.disabled = false;
          btn.textContent = CTXT.codeEntfernen;
          err.textContent = CTXT.entfernenFehler;
          err.hidden = false;
        });
    }

    renderStand(d) {
      var einloesbar = ganz(d.einloesbar);
      var max = ganz(d.hoechstbetrag);
      if (einloesbar <= 0) { this.verstecken(); return; }

      var html = this.kopf();
      if (d.gestoppt) {
        html += '<p class="kp-cart__line">' + esc(CTXT.gestoppt) + '</p></div>';
        this.zeigen(html);
        return;
      }
      if (max <= 0) {
        html += '<p class="kp-cart__line">' + esc(CTXT.nichtsFaehig(einloesbar)) + '</p>' + this.fuss();
        this.zeigen(html);
        return;
      }

      /* Hinweis nach Wunsch Fabsl (24.09.2026): X = hoechstbetrag vom Server, Regler voreingestellt
         auf den Höchstbetrag, damit man weniger einlösen und Punkte aufheben kann. */
      var faehig = arr(d.faehig).length, gesamt = faehig + arr(d.nicht_faehig).length;
      var idR = uid('kp-range'), idN = uid('kp-num'), idE = uid('kp-effekt'), idH = uid('kp-hint');
      var info = [CTXT.regel, CTXT.verfuegbar(einloesbar)];
      if (gesamt > 0 && faehig < gesamt) info.push(CTXT.faehigVon(faehig, gesamt));
      html += '<p class="kp-cart__teaser">' + esc(CTXT.teaser(max)) + '</p>';
      html += '<p class="kp-cart__meta">' + esc(info.join(' · ')) + '</p>';
      html += '<label class="kp-cart__label" for="' + idR + '">' + esc(CTXT.label) + '</label>';
      html += '<div class="kp-cart__controls">';
      html += '<input class="kp-cart__range" type="range" id="' + idR + '" min="0" max="' + max + '" step="1" value="' + max + '" aria-describedby="' + idE + ' ' + idH + '">';
      html += '<input class="kp-cart__number" type="number" id="' + idN + '" inputmode="numeric" min="0" max="' + max + '" step="1" value="' + max + '" aria-label="' + esc(CTXT.label) + '" aria-describedby="' + idE + ' ' + idH + '">';
      html += '</div>';
      html += '<p class="kp-cart__effect" id="' + idE + '" aria-live="polite">' + esc(CTXT.effekt(max)) + '</p>';
      if (this.probe) html += '<p class="kp-cart__probe">' + esc(CTXT.probe) + '</p>';
      html += '<button type="button" class="button kp-cart__submit">' + esc(CTXT.knopf) + '</button>';
      html += '<p class="kp-cart__error" role="alert" hidden></p>';
      html += '<p class="kp-cart__hint" id="' + idH + '">' + esc(CTXT.hinweis) + '</p>';
      html += this.fuss();
      this.zeigen(html);

      var self = this;
      var range = this.body.querySelector('.kp-cart__range');
      var num = this.body.querySelector('.kp-cart__number');
      var effekt = this.body.querySelector('.kp-cart__effect');
      var btn = this.body.querySelector('.kp-cart__submit');
      var err = this.body.querySelector('.kp-cart__error');

      function wert() {
        var v = ganz(num.value);
        if (v < 0) v = 0;
        if (v > max) v = max;
        return v;
      }
      function anzeigen(v) {
        effekt.textContent = CTXT.effekt(v);
        btn.disabled = self.busy || v <= 0;
      }
      function sync(v) {
        range.value = v;
        num.value = v;
        anzeigen(v);
      }
      range.addEventListener('input', function () { sync(ganz(range.value)); });
      num.addEventListener('input', function () {
        var v = ganz(num.value);
        if (v < 0) v = 0;
        if (v > max) v = max;
        range.value = v;
        anzeigen(v);
      });
      num.addEventListener('change', function () { sync(wert()); });
      num.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); sync(wert()); btn.click(); } });

      btn.addEventListener('click', function () {
        if (self.busy) return;
        var betrag = wert();
        sync(betrag);
        if (betrag <= 0) return;
        self.busy = true;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = CTXT.knopfLaeuft;
        err.hidden = true;
        /* Probebetrieb (Section-Einstellung, Auslieferungszustand aus): kein echter Aufruf. */
        var aufruf = self.probe
          ? new Promise(function (resolve) { setTimeout(function () { resolve({ status: 200, data: { ok: true, code: 'BONUS-PROBE', betrag: betrag } }); }, 400); })
          : api(self.urlEinloesen, { method: 'POST', body: { betrag: betrag, positionen: self.positionen } });
        aufruf.then(function (r) {
          var d = r.data;
          if (r.status === 200 && d && d.ok === true && d.code) {
            /* Shopify legt den Code in die Sitzung; der Warenkorb zeigt ihn danach an den Prämienzeilen. */
            window.location.href = '/discount/' + encodeURIComponent(d.code) + '?redirect=' + encodeURIComponent(self.cartUrl);
            return;
          }
          var grund = d && d.grund ? String(d.grund) : '';
          var msg = CTXT.fehler;
          if (/gestoppt/i.test(grund)) msg = CTXT.gestoppt; /* Grund ist intern, nicht anzeigen */
          else if (r.status === 401) msg = CTXT.nochmalAnmelden;
          else if (r.status === 503) msg = CTXT.spaeter;
          else if (r.status === 403) { console.warn('[punkte] App-Proxy antwortet 403 (Signatur/Konfiguration).', d); msg = CTXT.spaeter; }
          else if (/nicht gedeckt/i.test(grund)) msg = CTXT.nichtGedeckt;
          else if (/praemienfaehig/i.test(grund)) msg = CTXT.nichtsFaehig(einloesbar);
          else if (grund) msg = CTXT.fehler + ' (' + grund + ')';
          self.fehler(msg, btn, err);
        }).catch(function () { self.fehler(CTXT.fehler, btn, err); });
      });
    }

    fehler(msg, btn, err) {
      this.busy = false;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = CTXT.knopf;
      err.textContent = msg;
      err.hidden = false;
    }
  }
  if (!customElements.get('punkte-warenkorb')) customElements.define('punkte-warenkorb', PunkteWarenkorb);

  window.KasaPunkte = { version: 6 };
})();
